/**
 * Русские правила множественного числа. Возвращает форму, соответствующую
 * числу `n`: `forms[0]` — «один» (1, 21, 31, ...), `forms[1]` — «два-четыре»
 * (2-4, 22-24, ...), `forms[2]` — «много» (0, 5-20, 25-30, ...).
 *
 * Алгоритм: CLDR-style Russian plural rule.
 *   n % 10 === 1 && n % 100 !== 11 → one
 *   n % 10 in 2..4 && n % 100 not in 12..14 → few
 *   иначе → many
 */
export const pluralizeRu = (n: number, forms: [string, string, string]): string => {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
};

export const toggleSetMember = <T>(set: ReadonlySet<T>, value: T): Set<T> => {
  const next = new Set(set);
  if (next.has(value)) next.delete(value);
  else next.add(value);
  return next;
};